import { Button, ButtonProps } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

interface ButtonLinkProps extends ButtonProps {
  to: string;
  target?: string;
}

export const ButtonLink = (props: ButtonLinkProps) => {
  const { to, target } = props;
  return props.isDisabled 
  ? <Button {...props} isDisabled>{props.children}</Button> 
  : <Button {...props} as={Link} to={to} target={target}>{props.children}</Button>;
}